/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Notification General Alert Icon component.
 */
export const NotificationGeneralAlertIcon = ({color = dlsColor('white')}: IconProps) => {
  const {iconColor} = useIconDLS({color});
  return (
    <svg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M10.75 5.75V12.1292' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M10.75 13.2784V15.042' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <circle cx='10.75' cy='10.75' r='10' stroke={iconColor} strokeWidth='1.5' />
    </svg>
  );
};

export default NotificationGeneralAlertIcon;
